import { CarouselLayout, GenericCarouselLayout } from '../../common';
import { Screen } from '../services';

// !!IMPORTANT!!
// if you update these item display values, also update the --element-count css variable value
// in the carousel.component.scss file's matching class definitions
export const CAROUSEL_ITEM_DISPLAY = {
  [CarouselLayout.LandscapeLarge]: { [Screen.XS]: 2, [Screen.SM]: 4, [Screen.MD]: 4, [Screen.LG]: 4, [Screen.XL]: 4 },
  [CarouselLayout.LandscapeSmall]: { [Screen.XS]: 3, [Screen.SM]: 4, [Screen.MD]: 4, [Screen.LG]: 6, [Screen.XL]: 6 },
  [CarouselLayout.PortraitSmall]: { [Screen.XS]: 3, [Screen.SM]: 6, [Screen.MD]: 8, [Screen.LG]: 8, [Screen.XL]: 8 },
  [CarouselLayout.PortraitLarge]: { [Screen.XS]: 3, [Screen.SM]: 6, [Screen.MD]: 6, [Screen.LG]: 6, [Screen.XL]: 6 },
  [CarouselLayout.PortraitTop10]: { [Screen.XS]: 3, [Screen.SM]: 4, [Screen.MD]: 4, [Screen.LG]: 4, [Screen.XL]: 4 },
  [GenericCarouselLayout.Large]: { [Screen.XS]: 2, [Screen.SM]: 3, [Screen.MD]: 3, [Screen.LG]: 3, [Screen.XL]: 3 },
  [GenericCarouselLayout.Medium]: { [Screen.XS]: 2, [Screen.SM]: 4, [Screen.MD]: 4, [Screen.LG]: 4, [Screen.XL]: 4 },
  [GenericCarouselLayout.Small]: { [Screen.XS]: 2, [Screen.SM]: 6, [Screen.MD]: 6, [Screen.LG]: 6, [Screen.XL]: 6 },
};

export const CAROUSEL_ITEM_ASPECT_RATIO = {
  [CarouselLayout.LandscapeLarge]: 'landscape' as const,
  [CarouselLayout.LandscapeSmall]: 'landscape' as const,
  [CarouselLayout.PortraitSmall]: 'portrait' as const,
  [CarouselLayout.PortraitLarge]: 'portrait' as const,
  [CarouselLayout.PortraitTop10]: 'portrait' as const,
  [GenericCarouselLayout.Small]: 'landscape' as const,
  [GenericCarouselLayout.Medium]: 'landscape' as const,
  [GenericCarouselLayout.Large]: 'landscape' as const,
};

export type CarouselItemLayout = typeof CAROUSEL_ITEM_ASPECT_RATIO[keyof typeof CAROUSEL_ITEM_ASPECT_RATIO];
